import React, { lazy } from 'react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 px-4 bg-[#0B1A2E]" data-id="element-102">
      <div className="max-w-3xl mx-auto animate-fade-in-up delay-100" data-id="element-103">
        <p className="text-xl md:text-2xl italic text-[#F1F5F9] font-serif leading-relaxed mb-12 border-l-4 border-[#2DD4BF] pl-6 py-2" data-id="element-104">
          It’s 3:30 PM. You have ten tabs open, a lukewarm cup of coffee you’ve
          reheated twice, and a mounting sense of dread in your chest. You know
          exactly what you need to do, but you are physically unable to start.
        </p>

        <p className="text-lg text-[#94A3B8] mb-12" data-id="element-105">
          You aren’t lazy. You aren't "losing it" as you get older. Your brain
          is simply hunting for the chemical fuel it needs to engage—and it’s
          starving.
        </p>

        <div className="bg-[#112240] rounded-2xl p-8 md:p-10 border border-[#1A2F4A] relative overflow-hidden" data-id="element-106">
          <div className="absolute top-0 left-0 w-1 h-full bg-[#D4A843]" data-id="element-107" />

          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#F1F5F9] mb-6" data-id="element-108">
            The "Shame Spiral"
          </h2>

          <div className="space-y-6 text-[#94A3B8] leading-relaxed" data-id="element-109">
            <p data-id="element-110">
              For high-performing professionals over 45, ADHD isn't about being
              high-energy; it's about the "Shame Spiral." It's the exhaustion of
              masking your struggle for decades, only to find that your old
              coping mechanisms—like using sheer anxiety to meet a deadline—are
              finally breaking your health.
            </p>
            <p data-id="element-111">
              You spend your mornings "getting ready to work," your afternoons
              in a frozen state of paralysis, and your evenings working until 11
              PM to make up for the "lost day."
            </p>
            <p className="text-[#F1F5F9] font-medium" data-id="element-112">
              This cycle is burning you out and stealing your life.
            </p>
          </div>
        </div>
      </div>
    </section>;
}